@if (AiAssistantForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="AiAssistantForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <clickatell-form-validation [controlName]="'name'"
            [form]="AiAssistantForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="AiAssistantForm" id="name"
              [formControlName]="'name'" placeholder="Enter a name">
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Connection message </label>
                <label class="control-optional">Optional</label>
              </div>
              <textarea class="control-textArea" activeForm [activeForm]="AiAssistantForm" id="text"
              [formControlName]="'text'" placeholder="Enter a connection message"></textarea>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Initial prompt </label>
                <label class="control-optional">Optional</label>
              </div>
              <input class="control-input" activeForm [activeForm]="AiAssistantForm" id="initPrompt"
                [formControlName]="'initPrompt'" placeholder="Enter a Initial message">
              </div>
              <div class="control-div">
                <!--                    <div class="control-label-container">-->
                <!--                        <label class="control-label"> AI Intent</label>-->
              <!--                    </div>-->
              <mat-button-toggle-group #modeGroup="matButtonToggleGroup"
                [value]="AiAssistantForm?.controls['inferenceType']?.value"
                [multiple]="false"
                [formControlName]="'inferenceType'"
                (change)="modeChanged(modeGroup)"
                class="control-input control-toggle-group"
                hideSingleSelectionIndicator>
                <mat-button-toggle class="selector-button" [value]="'assistant'">Assistant</mat-button-toggle>
                <mat-button-toggle class="selector-button" [value]="'context_router'">Context router
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            @switch (modeGroup.value) {
              @case ('assistant') {
                <ng-container [ngTemplateOutlet]="assistantMode"></ng-container>
              }
              @case ('context_router') {
                <div class="control-div toggle-field">
                  <div class="label-left-block">
                    <label class="control-label"> Enable Routing Message </label>
                  </div>
                  <div class="toggle-btn">
                    <mat-slide-toggle [color]="'primary'" class="control-toggle"
                      [formControlName]="'enableRoutingMessage'">
                    </mat-slide-toggle>
                  </div>
                </div>
              }
            }
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <ng-container [formGroup]="AiAssistantForm">
            <div class="control-result">
              <div class="control-result-header">
                <div>
                  <img src="/assets/svg/success.svg">
                </div>
                <div>
                  Success
                </div>
              </div>
              <div class="control-result-container">
                @if (AiAssistantForm.controls.successDescription.status !== 'DISABLED') {
                  <div class="control-div"
                    >
                    <div class="control-label-container">
                      <label class="control-label"> Description </label>
                    </div>
                    <clickatell-form-validation [controlName]="'successDescription'"
                    [form]="AiAssistantForm"></clickatell-form-validation>
                    <input class="control-input" activeForm [activeForm]="AiAssistantForm"
                      id="successDescription"
                      [formControlName]="'successDescription'" placeholder="Enter a description"/>
                    </div>
                  }
                  <div class="control-div">
                    <label class="control-label">
                      <span class="pont-to">Point To</span>
                      <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    </label>
                    @if (nodeFlowDetails) {
                      <next-selector [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'successNext'"
                        [form]="AiAssistantForm"
                        [stepId]="nodeFlowDetails.stepId">
                      </next-selector>
                    }
                  </div>
                </div>
              </div>
              <div class="control-result">
                <div class="control-result-header">
                  <div>
                    <img src="/assets/svg/redesign/nodes/right-panel/error.svg">
                  </div>
                  <div>
                    Error
                  </div>
                </div>
                <div class="control-result-container">
                  @if (AiAssistantForm.controls.errorDescription.status !== 'DISABLED') {
                    <div class="control-div"
                      >
                      <div class="control-label-container">
                        <label class="control-label"> Description </label>
                      </div>
                      <clickatell-form-validation [controlName]="'errorDescription'"
                      [form]="AiAssistantForm"></clickatell-form-validation>
                      <input class="control-input" activeForm [activeForm]="AiAssistantForm" id="errorDescription"
                        [formControlName]="'errorDescription'" placeholder="Enter a description"/>
                      </div>
                    }
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'errorNext'"
                          [form]="AiAssistantForm"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }


      <ng-template #assistantMode>

        @if (assistantIds) {
          <ng-container [formGroup]="AiAssistantForm">
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Select Assistant </label>
              </div>
              <clickatell-form-validation [controlName]="'assistantId'"
              [form]="AiAssistantForm"></clickatell-form-validation>
              <div class="parent">
                <input type="text"
                  #assistantId
                  placeholder="Search or select an Assistant"
                  matInput
                  [id]="'assistantId'"
                  [activeForm]="AiAssistantForm"
                  class="layer1 control-select control-select-spacer"
                  [formControlName]="'assistantId'"
                  [matAutocomplete]="auto"
                  (input)="assistantIdFilter(assistantId)"
                  />
                </div>
                <mat-autocomplete
                  autoActiveFirstOption
                  #auto="matAutocomplete"
                  [displayWith]="assistantIdDisplay.bind(this)"
                  >
                  <ng-container>
                    @if (assistantIds) {
                      @if (assistantIdsFiltered.length == 0) {
                        <mat-option disabled
                          class="data-select-option-nonfound resNotFound"
                          [ngStyle]="{ 'line-height': 1 }">
                          No results found.
                        </mat-option>
                      }
                      @if (assistantIdsFiltered.length > 0  && assistantIdsFiltered[0].assistantId != null) {
                        @for (assistant of assistantIdsFiltered; track assistant) {
                          <mat-option
                            [value]="assistant.assistantId"
                            [ngClass]="{'select-dropdown-option': assistant.assistantId === AiAssistantForm.controls['assistantId'].value}">
                            {{ assistant.name }}
                          </mat-option>
                        }
                      }
                      @if (assistantIds[0].assistantId == null) {
                        <mat-option disabled class="data-select-option-nonfound resNotFound"
                          [ngStyle]="{ 'line-height': 1 }">
                          No Assistants available.
                        </mat-option>
                      }
                    }
                  </ng-container>
                </mat-autocomplete>
              </div>
            </ng-container>
          } @else {
            <loading-icon class="align-loading"></loading-icon>
          }


        </ng-template>